import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "../utils/ui-components";

@customElement("alert-modal")
export class AlertModal extends BaseElement {
    @property()
    message = "";

    @property()
    onClose?: () => void;

    render() {
        return html`
            <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
                <div class="fixed inset-0 bg-black/50" @click=${() => this.onClose?.()}></div>
                <div class="relative bg-white rounded-lg shadow-lg max-w-md w-full">
                    <div class="p-6">
                        <div class="text-sm text-gray-600">${this.message}</div>
                        <div class="mt-6 flex justify-end">
                            <button
                                @click=${() => this.onClose?.()}
                                class="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 bg-gray-100 hover:bg-gray-200 rounded-md"
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
